document.addEventListener('DOMContentLoaded', function () {
  var interval = setInterval(function () {
    var discountLabel = document.querySelector('.subscription-radio .discount-label');

    if (discountLabel) {
      if (discountLabel.textContent !== 'Subscribe') {
        let strarr = discountLabel.textContent.split(' ');
        strarr.splice(strarr.length - 1, 1);
        discountLabel.innerHTML = strarr.join(' ');
      } else {
        // If it's "Subscribe", just update the innerHTML without modification
        discountLabel.innerHTML = discountLabel.textContent;
      }
      clearInterval(interval); // Clear the interval once the action is performed
      setTimeout(function () {
        document.querySelector('.recharge-subscription-widget').style.visibility = 'visible';
      }, 100);
    }
  }, 20); // Check every 100 milliseconds
});
